import { FormControl } from '@mui/base';
import { Add, Info } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Alert,
    AlertTitle,
    AppBar,
    Box,
    Breadcrumbs,
    Button,
    Card,
    CircularProgress,
    Container,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    InputAdornment,
    Menu,
    MenuItem,
    Modal,
    Select,
    Skeleton,
    Stack,
    TextField,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { Suspense, useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Context } from '../../../App';
import AddCustomerModalV4 from '../../../common/AddCustomerModalV4';
import CommonDialog from '../../../common/CommonDialog';
import CarfaxHistoryModel from '../../../components/Models/CarfaxHistoryModel';
import VehicleModalV4 from '../../../common/VehicleModalV4';
import { APEX_AUTO_APP, SHOP_CREATED, SHOP_IMPORTED, USER_TYPES, WALK_IN } from '../../../config/dataService/constants';
import { configDetails } from '../../../redux/Account/action';
import {
    addNote,
    addVehicle,
    customerAppointments,
    customerDetail,
    customerVehicles,
    decodeVIN,
    deleteCustomer,
    deleteCustomerNote,
    deleteCustomerVehicle,
    deleteImportedVehicle,
    editCustomer,
    editCustomerNote,
    editCustomerVehicle,
    editImportedVehicle,
    getNotesListing,
    importedCustomerDetail,
    vehicleMakeMaster,
    vehicleModelMaster,
    vehicleTrimMaster,
    vehicleYearMaster,
} from '../../../redux/Customer/action';
import { appointmentDetails } from '../../../redux/appointment/action';
import CustomerCar from '../../../utility/Svg/CustomerCar';
import CustomerFleet from '../../../utility/Svg/CustomerFleet';
import CustomerLicencePlate from '../../../utility/Svg/CustomerLicencePlate';
import CustomerTrim from '../../../utility/Svg/CustomerTrim';
import CustomerVin from '../../../utility/Svg/CustomerVin';
import { getItem, removeItem, setItem } from '../../../utility/localStorage';
import { checkValidVIN } from '../../../utility/utilityFunctions';
import AppointmentModel from '../../Appointment/AppointmentModel';
import ViewUpcomingModal from '../../Appointment/UpcomingAppointment/ViewUpcomingModal';
import AppointmentRequestModal from '../../modal/AppointmentrequestModal';
import GuestCustomerInfoModal from '../GuestCustomers/GuestCustomerInfoModal.jsx';
import ConvertCustomerModal from '../GuestCustomers/ConvertCustomerModal.jsx';
import '../Customers.css';
import AppointmentTab from './AppointmentTab';
import CustomerProfileLeftDataSection from './CustomerProfileLeftDataSection';
import CustomerProfileQuickEdit from './CustomerProfileQuickEdit';
import EstimateTab from './EstimateTab';
import InvoiceTab from './InvoiceTab';
import './Profile.css';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: '2px solid ',
    boxShadow: 24,
};

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Profile = () => {
    const { id, type } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isOpenSideBar } = useContext(Context);
    const isGuestCustomer = type === 'shop_guest';
    const [quickEdit, setQuickEdit] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [openEditCustomer, setOpenEditCustomer] = React.useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [openVehicleDelete, setOpenVehicleDelete] = React.useState(false);
    const [vinLoading, setVINLoading] = useState(false);

    const [openViewVehicle, setOpenViewVehicle] = React.useState(false);
    const [editVehicle, setEditVehicle] = useState({
        edit: false,
        index: '',
        id: '',
    });
    const [deleteVehicleId, setDeleteVehicleId] = useState('');
    const [editDeleteNoteId, setEditDeleteNoteId] = useState('');
    const [editNoteText, setEditNoteText] = useState('');
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [successMessageType, setSuccessMessageType] = useState('success');

    const [selectedActionOfNote, setSelectedActionOfNote] = useState('');
    const [make, setMake] = useState([]);
    const [model, setModel] = useState([]);
    const [trim, setTrim] = useState([]);
    const [appointmentModalLoader, setAppointmentModalLoader] = useState(false);
    const [modelLoader, setModelLoader] = useState(false);
    const [trimLoader, setTrimLoader] = useState(false);
    const [completeAddress, setCompleteAddress] = useState({});
    const [placeId, setPlaceId] = useState('');
    const [getAddress, setAddress] = useState();
    const [addCustomerInfoButton, setAddCustomerInfoButton] = React.useState(false);
    const [makeLoader, setMakeLoader] = useState(false);
    const [viewVehicleData, setViewVehicleData] = useState(null);
    //Hide Edit Delete buttons in view vehicle model based on isConverted
    const [showEditDeleteInViewModel, setShowEditDeleteInViewModel] = useState(true);
    const [openCarfaxHistory, setOpenCarfaxHistory] = useState(false);
    const [addressValues, setAddressValue] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
    });
    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue: setValueinForm,
        getValues,
        setError,
        clearErrors,
    } = useForm();

    const [openAppointmentDetailModal, setOpenAppointmentDetailModal] = useState(false);

    const [openAppReqModal, setOpenAppReqModal] = useState(false);
    const [openGuestModal, setOpenGuestModal] = useState(false);
    const [openGuestConvertModal, setOpenGuestConvertModal] = useState(false);

    const [appointmentDetailData, setAppointmentDetailData] = useState(null);
    const [vehicles, setvehicles] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open1 = Boolean(anchorEl);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);

        setEditVehicle({ edit: false, index: '', id: '' });
        setImportedVehicleId(null);
        reset();
        setValueinForm('year', '');

        setValueinForm('vehicleMakeId', '');
        setValueinForm('vehicleModelId', '');
        setValueinForm('vehicleModelTrimId', '');

        setYearValue('');
        setMakeValue('');
        setModelValue('');
        setTrimValue('');
    };
    const handleCloseCustomer = () => setOpenEditCustomer(false);
    const handleCloseDelete = () => setOpenDelete(false);

    const handleCloseDeleteVehicle = () => {
        setOpenVehicleDelete(false);
        setDeleteVehicleId('');
        setImportedVehicleId(null);
    };

    const handleCloseViewVehicle = () => {
        setOpenViewVehicle(false);
        // setImportedVehicleId(null);
    };
    const handleCloseCarfaxHistory = () => {
        setOpenCarfaxHistory(false);
    };
    const [appointmentPage, setAppointmentPage] = useState(1);
    const [appointmentLimit, setAppointmentLimit] = useState(10);

    const [yearValue, setYearValue] = useState('');
    const [makeValue, setMakeValue] = useState('');
    const [modelValue, setModelValue] = useState('');
    const [trimValue, setTrimValue] = useState('');

    const [makeValuePage, setMakeValuePage] = useState(1);
    const [modelValuePage, setModelValuePage] = useState(1);
    const [trimValuePage, setTrimValuePage] = useState(1);
    const [customerNotePage, setCustomerNotePage] = useState(1);
    const [newNote, setNewNote] = useState('');
    const [noteError, setNoteError] = useState(false);
    const [yearPageLimit, setYearPageLimit] = useState({ page: 1, limit: 1000 });
    // const customerProfileTabs = getItem('customerProfileTabs');
    const [value, setValue] = useState(0);

    const [showUpcomingModal, setShowUpcomingModal] = useState(false);
    const [importedCustomerData, setImportedCustomerData] = useState({});
    const [country, setCountry] = useState();
    // const [openCustomerInfo, setOpenCustomerInfo] = React.useState(false);
    const [openAddCustomerModal, setOpenAddCustomerModal] = useState(false);
    const [convertedCustomerId, setCustomerConvertedId] = useState(null);
    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [importedVehicleId, setImportedVehicleId] = useState(null);
    const theme = useTheme();
    const [viewVehicleModalTabvalue, setViewVehicleModalTabValue] = useState(0);
    const handleChangeViewVehicleTabValue = (event, newValue) => {
        setViewVehicleModalTabValue(newValue);
    };
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const select_category = [
        { label: 'Inglourious Basterds', year: 2009 },
        { label: 'Snatch', year: 2000 },
        { label: '3 Idiots', year: 2009 },
        { label: 'Monty Python and the Holy Grail', year: 1975 },
    ];
    let appointmentParams = {
        page: appointmentPage,
        limit: appointmentLimit,
        customerId: id,
    };
    let vehicleMakeParams = {
        page: makeValuePage,
        limit: 100,
        year: yearValue,
    };
    let vehicleModelParams = {
        page: modelValuePage,
        limit: 100,
        vehicleMakeId: makeValue,
    };
    let vehicleTrimParams = {
        page: trimValuePage,
        limit: 100,
        vehicleMakeParams,
        vehicleModelId: modelValue,
    };
    let customerNoteParams = {
        page: customerNotePage,
        limit: 100,
        customerId: id,
    };

    const getDetails = () => {
        fetchCustomerDetail();
        fetchCustomerVehicle();
        // fetchCustomerAppointments(appointmentParams);
    };

    useEffect(() => {
        console.log('abc type', type);
        console.log('abc openAddCustomerModal', openAddCustomerModal);
        console.log('abc importedCustomerData', importedCustomerData.createdFrom);
    }, [openAddCustomerModal, importedCustomerData]);

    // const isConverted = getItem("converted");
    useEffect(() => {
        const converted = getItem('convertedCustomer');
        if (converted && converted.importedId == id) {
            navigate(`/customers/${converted.convertedId}/shop_created`, {
                replace: true,
            });
            removeItem('convertedCustomer');
            window.location.reload();
        }
    }, [getItem('convertedCustomer')]);

    useEffect(() => {
        if (convertedCustomerId) {
            getDetails();
        }
    }, [convertedCustomerId]);

    useEffect(() => {
        if (type != SHOP_IMPORTED && type != WALK_IN) {
            getDetails();
            // fetchCustomerNotes()

            fetchCustomerNotes(customerNoteParams);
        }
        if (type == SHOP_IMPORTED || type == WALK_IN) {
            fetchImportedCustomerDetail();
            setItem('customerProfileTabs', 0);
            setValue(0);
        }
        fetchConfig();

        // fetchVehicleYear(yearPageLimit.page, yearPageLimit.limit);
        // fetchVehicleMake(vehicleMakeParams);
    }, []);
    const fetchConfig = async () => {
        await dispatch(configDetails());
    };
    const config = useSelector((state) => state.account.configDetailData);
    const fetchImportedCustomerDetail = async () => {
        setShowLoader(true);

        const resp = await dispatch(importedCustomerDetail(id));
        setImportedCustomerData(resp);
        setvehicles(resp?.vehicle);
        setShowLoader(false);
    };

    const fetchCustomerDetail = async () => {
        setShowLoader(true);

        await dispatch(customerDetail(id));
        setShowLoader(false);
    };
    const data = useSelector((state) => state.customer.customerDetail);

    const guestModalUserData = React.useMemo(
        () => ({
            customer: data,
            vehicle: {},
        }),
        [data]
    );

    const guestConvertUserId = React.useMemo(
        () => ({
            customer: { _id: id },
        }),
        [id]
    );

    useEffect(() => {
        setAddress(data?.streetAddress);
    }, [data]);
    const fetchCustomerVehicle = async () => {
        setShowLoader(true);

        await dispatch(customerVehicles(id));
        setShowLoader(false);
    };
    const vehiclesData = useSelector((state) => state.customer.customerVehicle);

    useEffect(() => {
        if (type != SHOP_IMPORTED) setvehicles(vehiclesData);
    }, [vehiclesData]);

    const fetchCustomerAppointments = async (appointmentParams) => {
        setShowLoader(true);

        await dispatch(customerAppointments(appointmentParams));
        setShowLoader(false);
    };
    const appointments = useSelector((state) => state.customer.customerAppointment);

    const fetchVehicleYear = async (yearPage, yearLimit) => {
        await dispatch(vehicleYearMaster({ page: yearPage, limit: yearLimit }));
    };
    const year = useSelector((state) => state.customer?.vehicleYear);

    const fetchVehicleMake = async (vehicleMakeParams) => {
        setMakeLoader(true);
        await dispatch(vehicleMakeMaster(vehicleMakeParams));
        setMakeLoader(false);
    };
    const makes = useSelector((state) => state.customer?.vehicleMake);
    useEffect(() => {
        setMake(makes);
    }, [makes]);
    const fetchVehicleModel = async (vehicleModelParams) => {
        setModelLoader(true);
        await dispatch(vehicleModelMaster(vehicleModelParams));
        setModelLoader(false);
    };
    const models = useSelector((state) => state.customer?.vehicleModel);
    useEffect(() => {
        setModel(models);
    }, [models]);
    const fetchVehicleTrim = async (vehicleTrimParams) => {
        setTrimLoader(true);
        await dispatch(vehicleTrimMaster(vehicleTrimParams));
        setTrimLoader(false);
    };
    const trims = useSelector((state) => state.customer?.vehicleTrim);
    useEffect(() => {
        setTrim(trims);
    }, [trims]);
    const fetchCustomerNotes = async (customerNoteParams) => {
        await dispatch(getNotesListing(customerNoteParams));
    };

    const notes = useSelector((state) => state.customer.notesList);

    const handleAddNote = async () => {
        if (!newNote) {
            return setNoteError(true);
        }
        setNoteError(false);

        let payload = {
            customerId: id,
            notes: newNote,
        };
        const resp = await dispatch(addNote(payload));
        setNewNote('');
        if (resp) {
            fetchCustomerNotes(customerNoteParams);
            setOpenSuccessModal(true);
            setSuccessMessage('Note Added');
        }
    };
    const handleCloseAppointmentDetailModal = () => {
        setOpenAppointmentDetailModal(false);
        // fetchCustomerAppointments(appointmentParams);
    };
    const getAppointmentDetails = async (id) => {
        setAppointmentModalLoader(true);

        const detailView = await dispatch(appointmentDetails(id));

        if (detailView) {
            setAppointmentModalLoader(false);
            setAppointmentDetailData(detailView);

            if (detailView?.requestStatus === 'pending') {
                setOpenAppReqModal(true);
            } else {
                if (dayjs(detailView?.dropOffDateTime).format('YYYY-DD-MM') <= dayjs().format('YYYY-DD-MM')) {
                    setOpenAppointmentDetailModal(true);
                } else {
                    setShowUpcomingModal(true);
                }
            }
        }

        setAppointmentModalLoader(false);
    };
    const onSubmit = async (values) => {
        if (values?.vin && values?.vin !== '') {
            if (checkValidVIN(values?.vin)) {
                clearErrors('vin');
            } else {
                return setError('vin', { message: 'Please enter valid VIN' });
            }
        }
        let payload = {
            // ...values,
            year: values?.year,
            vehicleMakeId: values?.vehicleMakeId,
            vehicleModelId: values?.vehicleModelId,
            // vehicleModelTrimId: values?.vehicleModelTrimId,
            vin: values?.vin,
            licenseNumber: values.licenseNumber,
            customerId: id,
        };

        if (!values?.vin) {
            delete payload['vin'];
        }

        if (values.vehicleModelTrimId) {
            payload.vehicleModelTrimId = values?.vehicleModelTrimId;
        }
        setShowLoader(true);
        if (editVehicle?.edit) {
            let resp = '';
            if (importedVehicleId) {
                resp = await dispatch(editImportedVehicle(importedVehicleId, payload));
            } else {
                resp = await dispatch(editCustomerVehicle(editVehicle.id, payload));
            }
            if (resp) {
                setEditVehicle({ edit: false, index: '', id: '' });
                handleClose();
                reset();
                setMakeValue('');
                setYearValue('');
                setModelValue('');
                setTrimValue('');
                setImportedVehicleId(null);
                fetchCustomerVehicle();
                setOpenSuccessModal(true);
                setSuccessMessage('Vehicle Updated');
            }
        } else {
            const resp = await dispatch(addVehicle(payload));
            if (resp?.status) {
                handleClose();
                reset();
                setMakeValue('');
                setYearValue('');
                setModelValue('');
                setTrimValue('');
                fetchCustomerVehicle();
                setOpenSuccessModal(true);
                setSuccessMessage('New Vehicle Added');
            }
        }
        setShowLoader(false);
        // if (resp) {

        // }
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setItem('customerProfileTabs', newValue);
    };

    useEffect(() => {
        const isLimitedProfile = type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer;
        if (isLimitedProfile && value > 1) {
            setValue(0);
            setItem('customerProfileTabs', 0);
        }
    }, [type, isGuestCustomer, value]);

    function handleClick(event) {
        event.preventDefault();
        // console.info("You clicked a breadcrumb.");
    }
    const onSubmitCustomer2 = async (resp) => {
        setShowLoader(false);
        handleCloseCustomer();
        fetchCustomerDetail();
        if (resp) {
            setOpenSuccessModal(true);
            setSuccessMessage('Customer Details Updated');
            setSuccessMessageType('success');
            if (quickEdit) {
                setQuickEdit(false);
            }
        }
    };

    const onSubmitCustomer = async (values) => {
        let payload = {
            // ...values,
            phoneNumber: values.phoneNumber,
            // countryCode: "+1",
        };
        if (values?.firstName) {
            payload.firstName = values.firstName.trim();
        }
        if (values?.lastName) {
            payload.lastName = values.lastName.trim();
        }
        // if (values.email) {
        //   payload.email = values?.email;
        // }

        // if (values?.company) {
        payload.company = values?.company;
        payload.taxExemptionNumber = values?.taxExemptionNumber || '';
        // }
        if (addressValues?.city) {
            payload.city = addressValues?.cityId;
        }

        if (addressValues?.country) {
            payload.country = '64e738882fec8f2c9b79c139';
        }

        payload.postalCode = values?.postalCode;

        if (addressValues?.province) {
            payload.province = addressValues?.provinceId;
        }
        payload.streetAddress = values?.streetAddress;

        if (values?.contactPrefrence) {
            payload.contactPrefrence = values?.contactPrefrence;
        }
        if (values?.primaryPhoneNumberType) {
            payload.primaryPhoneNumberType = values?.primaryPhoneNumberType;
            payload.countryCode = values?.countryCode;
            payload.phoneNumberCountry = values?.phoneNumberCountry;
        }

        payload.secondaryPhoneNumberType = values?.secondaryPhoneNumberType;
        payload.secondaryPhoneNumber = values?.secondaryPhoneNumber;

        if (values?.secondaryPhoneNumber) {
            payload.secondaryPhoneNumberCountryCode = values?.secondaryPhoneNumberCountryCode;
            payload.secondaryPhoneNumberCountry = values?.secondaryPhoneNumberCountry;
        }

        if (primaryEmailIndex == 0) {
            payload.email = values?.email;
            payload.secondaryEmail = values?.secondaryEmail;
        } else {
            payload.secondaryEmail = values?.email;
            payload.email = values?.secondaryEmail;
        }

        if (values.membershipProgram && values.membershipProgram !== '' && values.membershipProgram !== 'none') {
            payload.membershipProgram = values.membershipProgram;
        } else {
            payload.membershipProgram = '';
        }

        // if (primaryEmailIndex == 0) {
        //   if (values.email) {
        //     payload.email = values.email;
        //   } else {
        //     // return displayError("Please enter email");
        //     // payload.email = "";
        //   }
        //   if (values?.secondaryEmail) {
        //     payload.secondaryEmail = values?.secondaryEmail;
        //   }
        // } else {
        //   if (values?.secondaryEmail) {
        //     payload.email = values?.secondaryEmail;
        //   }
        //   if (values?.email) {
        //     payload.secondaryEmail = values?.email;
        //   }
        // }

        setShowLoader(true);
        const resp = await dispatch(editCustomer(id, payload));
        setShowLoader(false);
        handleCloseCustomer();
        fetchCustomerDetail();
        if (resp) {
            setOpenSuccessModal(true);
            setSuccessMessage('Customer Details Updated');
            setSuccessMessageType('success');
            if (quickEdit) {
                setQuickEdit(false);
            }
        }
    };

    const handleDeleteVehicle = async () => {
        setShowLoader(true);
        let resp = '';
        if (importedVehicleId) {
            resp = await dispatch(deleteImportedVehicle(importedVehicleId));
            setImportedVehicleId(null);
            if (type == SHOP_IMPORTED || type == WALK_IN) fetchImportedCustomerDetail();
        } else {
            resp = await dispatch(deleteCustomerVehicle(deleteVehicleId));
            setDeleteVehicleId('');
        }

        handleCloseDeleteVehicle();
        handleClose();
        setDeleteVehicleId('');
        handleCloseViewVehicle();
        // handleCloseDelete();
        fetchCustomerVehicle();
        setShowLoader(false);
        if (resp) {
            setOpenSuccessModal(true);
            setSuccessMessage('Vehicle Deleted');
        }
    };
    const [anchorElAtions, setAnchorElActions] = React.useState(null);
    const openNoteActions = Boolean(anchorElAtions);

    const handleClickNoteActions = (event, data) => {
        setSelectedActionOfNote(data);
        setAnchorElActions(event.currentTarget);
    };
    const handleCloseNoteActions = () => {
        setAnchorElActions(null);
        setSelectedActionOfNote('');
    };

    const editNote = async () => {
        let payload = { notes: editNoteText };
        setShowLoader(true);
        await dispatch(editCustomerNote(editDeleteNoteId?._id, payload));
        fetchCustomerNotes(customerNoteParams);
        // setShowLoader(false)
        setEditDeleteNoteId('');
        setEditNoteText('');
        setShowLoader(false);
        setOpenSuccessModal(true);
        setSuccessMessage('Note Updated');
    };
    const deleteNote = async (id) => {
        setShowLoader(true);
        await dispatch(deleteCustomerNote(id));
        fetchCustomerNotes(customerNoteParams);
        // setShowLoader(false)
        setEditDeleteNoteId('');
        setEditNoteText('');
        setShowLoader(false);
        setOpenSuccessModal(true);
        setSuccessMessage('Note Deleted');
    };

    const handleDecodeVIN = async () => {
        if (getValues()?.vin && getValues()?.vin.length == 17) {
            // setVINError("");
            clearErrors('vin');

            setVINLoading(true);

            const resp = await dispatch(decodeVIN(getValues()?.vin));
            // setModelSelectLoader(true);
            setMakeValue(resp?.data?.make?._id);
            setModelValue('');
            setTrimValue('');
            await dispatch(
                vehicleMakeMaster({
                    page: 1,
                    limit: 1000,
                    year: resp?.data?.year,
                })
            );
            let para = {
                page: 1,
                limit: 1000,
                vehicleMakeId: resp?.data?.make?._id,
                year: resp?.data?.year,
            };
            let maekResult = await dispatch(vehicleModelMaster(para));
            if (maekResult) {
                let para = {
                    page: 1,
                    limit: 1000,
                    vehicleMakeId: resp?.data?.make?._id,
                    vehicleModelId: resp?.data?.model?._id,
                    year: resp?.data?.year,
                };
                await dispatch(vehicleTrimMaster(para));
            }

            if (resp) {
                setValueinForm('year', resp?.data?.year + '');
                setValueinForm('vehicleMakeId', resp?.data?.make?._id);
                setValueinForm('vehicleModelId', resp?.data?.model?._id);
                setValueinForm('vehicleModelTrimId', resp?.data?.trim?._id);
                setYearValue(resp?.data?.year);
                setMakeValue(resp?.data?.make?._id);
                setModelValue(resp?.data?.model?._id);
                setTrimValue(resp?.data?.trim?._id);

                setVINLoading(false);
            }
        } else if (getValues()?.vin && getValues()?.vin.length != 17) {
            setVINLoading(false);
            // setVINError("Please Enter Valid VIN");
            setError('vin', {
                message: 'Please enter valid VIN',
            });
        } else {
            setVINLoading(false);
            setError('vin', {
                message: 'Please enter valid VIN',
            });
            // setVINError("Please Enter Valid VIN");

            // message.error("Please enter VIN number");
        }
    };
    const handleCloseUpComing = () => {
        setShowUpcomingModal(false);
    };
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const customerAddress = () => {
        let add = ' ';
        if (data?.streetAddress) {
            add += data?.streetAddress;
        }
        if (data?.city) {
            if (add.trim() != '') add += ', ' + data?.city?.city;
            else add += data?.city?.city;
        }
        if (data?.province) {
            if (add.trim() != '') add += ', ' + data?.province?.province;
            else add += data?.province?.province;
        }
        // if (data?.country) {
        //   add += data?.country?.country + ", ";
        // }
        if (data?.postalCode) {
            if (add.trim() != '') add += ', ' + data?.postalCode;
            else add += data?.postalCode;
        }
        return add;
    };
    const importCustomerAddress = () => {
        let add = ' ';
        if (importedCustomerData?.streetAddress) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.streetAddress;
            else {
                add += importedCustomerData?.streetAddress;
            }
        }
        if (importedCustomerData?.city) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.city?.city;
            else add += importedCustomerData?.city?.city;
        }
        if (importedCustomerData?.province) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.province?.province;
            else add += importedCustomerData?.province?.province;
        }
        // if (importedCustomerData?.country) {
        //   add += importedCustomerData?.country?.country + ", ";
        // }
        if (importedCustomerData?.postalCode) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.postalCode;
            else add += importedCustomerData?.postalCode;
        }
        return add;
    };

    if (showLoader)
        return (
            <Dialog open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        );
    return (
        <Box padding={'32px 24px'} sx={{ bgcolor: 'white', minHeight: 'calc(100vh - 64px)', height: '100%', background: '#FAFBFF' }}>
            <Grid container spacing={0} sx={{ padding: '16px 0px 16px 0px' }} gap={'8px'}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div role="presentation" onClick={handleClick}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                to="/customers"
                                style={{
                                    color: 'black',
                                    // opacity: "0.6",
                                    textDecoration: 'none',
                                }}
                                onClick={() => {
                                    removeItem('searchValue');
                                }}
                            >
                                Customers
                            </Link>
                            <Link
                                // to={`/customers/${id}`}
                                style={{ color: 'black', textDecoration: 'none' }}
                            >
                                <Typography color="black">
                                    {type == SHOP_IMPORTED || type == WALK_IN
                                        ? importedCustomerData?.firstName + ' ' + importedCustomerData?.lastName
                                        : data?.firstName + ' ' + data?.lastName}
                                </Typography>
                            </Link>
                        </Breadcrumbs>
                    </div>
                </Grid>

                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent={'space-between'} spacing={1} rowGap={2}>
                    <Grid item lg={isOpenSideBar ? 12 : 4} md={5} sm={12} xs={12} xl={3.2}>
                        <Typography variant="h4" sx={{ fontWeight: 500 }}>
                            Customer Profile
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={isOpenSideBar ? 12 : 8}
                        xl={8}
                        sx={{
                            display: 'flex',
                            justifyContent: { lg: isOpenSideBar ? 'start' : 'end', xl: 'end' },
                            flexWrap: { xs: 'wrap', md: 'nowrap' }, // Allow wrapping on smaller screens
                            gap: 2,
                            pointerEvents: quickEdit ? 'none' : 'auto',
                            opacity: quickEdit ? '0.5' : '',
                        }}
                        // columnGap={2}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                if (isGuestCustomer) {
                                    setOpenGuestModal(true);
                                    return;
                                }
                                if (type == WALK_IN) {
                                    setOpenAddCustomerModal(true);
                                    return;
                                }
                                navigate(
                                    `/appointment/new-appointment/${id}/${
                                        type
                                            ? type == SHOP_CREATED
                                                ? SHOP_CREATED
                                                : type == SHOP_IMPORTED
                                                  ? SHOP_IMPORTED
                                                  : APEX_AUTO_APP
                                            : data.createdFrom == SHOP_CREATED
                                              ? SHOP_CREATED
                                              : APEX_AUTO_APP
                                    }`
                                );
                            }}
                            size="large"
                        >
                            new appointment
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                if (isGuestCustomer) {
                                    setOpenGuestModal(true);
                                    return;
                                }
                                if (type == WALK_IN) {
                                    setOpenAddCustomerModal(true);
                                    return;
                                }
                                navigate(
                                    `/estimates/new/${id}/${
                                        type
                                            ? type == SHOP_CREATED
                                                ? SHOP_CREATED
                                                : type == SHOP_IMPORTED
                                                  ? SHOP_IMPORTED
                                                  : APEX_AUTO_APP
                                            : data.createdFrom == SHOP_CREATED
                                              ? SHOP_CREATED
                                              : APEX_AUTO_APP
                                    }`
                                );
                            }}
                            className="btn-text-size-manage"
                            size="large"
                        >
                            new estimate
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Add />}
                            sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            onClick={() => {
                                if (isGuestCustomer) {
                                    setOpenGuestModal(true);
                                    return;
                                }
                                if (type == WALK_IN) {
                                    setOpenAddCustomerModal(true);
                                    return;
                                }
                                navigate(
                                    `/invoice/new/${id}/${
                                        type
                                            ? type == SHOP_CREATED
                                                ? SHOP_CREATED
                                                : type == SHOP_IMPORTED
                                                  ? SHOP_IMPORTED
                                                  : APEX_AUTO_APP
                                            : data.createdFrom == SHOP_CREATED
                                              ? SHOP_CREATED
                                              : APEX_AUTO_APP
                                    }`
                                );
                            }}
                            className="btn-text-size-manage"
                            size="large"
                        >
                            new invoice
                        </Button>
                        {type != SHOP_IMPORTED && type != WALK_IN && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<Add />}
                                onClick={() => {
                                    if (isGuestCustomer) {
                                        setOpenGuestModal(true);
                                        return;
                                    }
                                    handleOpen();
                                }}
                                size="large"
                                sx={{ whiteSpace: 'nowrap' }} // Prevent label from wrapping
                            >
                                ADD VEHICLE
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                // padding={"24px"}
                // spacing={2}
                marginTop={'20px'}
                justifyContent={'space-between'}
            >
                <Grid
                    item
                    container
                    height={'fit-content'}
                    xs={12}
                    sm={12}
                    md={12}
                    lg={5.1}
                    xl={3.5}
                    sx={{
                        boxShadow: '0px 2px 16px 1px rgba(0, 0, 0, 0.12), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 4px 5px -2px rgba(0, 0, 0, 0.20)',
                        justifyContent: 'flex-start',
                        position: { md: 'relative', lg: 'sticky' },
                        top: { sm: 'auto', lg: '90px' },
                        scrollbarWidth: 'none',
                        background: '#fff',
                    }}
                    borderRadius={'4px'}
                    padding="24px"
                    marginTop={'26px'}
                >
                    {!quickEdit ? (
                        <CustomerProfileLeftDataSection
                            data={data}
                            importedCustomerData={importedCustomerData}
                            setOpenEditCustomer={setOpenEditCustomer}
                            setOpenDelete={setOpenDelete}
                            setQuickEdit={setQuickEdit}
                        />
                    ) : (
                        <CustomerProfileQuickEdit
                            data={data}
                            setQuickEdit={setQuickEdit}
                            onSubmitCustomer={onSubmitCustomer}
                            setAddressValues={setAddressValue}
                            addressValues={addressValues}
                            type={type}
                        />
                    )}
                </Grid>

                <Grid
                    item
                    container
                    xs={12}
                    md={12}
                    sm={12}
                    lg={6.9}
                    xl={8.5}
                    borderRadius={'4px'}
                    sx={{
                        pointerEvents: quickEdit ? 'none' : 'auto',
                        opacity: quickEdit ? '0.5' : '',
                        userSelect: quickEdit ? 'none' : '',
                    }}
                >
                    {/* <Grid item container xs={12} sm={12} md={12} xl={12}> */}
                    <Box sx={{ width: '100%', padding: '24px' }}>
                        <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab
                                    label="OVERVIEW"
                                    // style={{ display: type == SHOP_IMPORTED && "none" }}
                                    {...a11yProps(0)}
                                />

                                <Tab label="VEHICLES" {...a11yProps(1)} />

                                <Tab
                                    label="APPOINTMENTS"
                                    style={{ display: (type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer) && 'none' }}
                                    {...a11yProps(2)}
                                />
                                <Tab
                                    label="Invoices"
                                    style={{ display: (type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer) && 'none' }}
                                    {...a11yProps(3)}
                                />
                                <Tab
                                    label="Estimates"
                                    style={{ display: (type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer) && 'none' }}
                                    {...a11yProps(4)}
                                />
                            </Tabs>
                        </Box>

                        <CustomTabPanel
                            value={value}
                            index={0}
                            // style={{ display: type == SHOP_IMPORTED && "none" }}
                        >
                            <Grid container>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}
                                    justifyContent={'space-between'}
                                    // spacing={2}
                                    borderRadius={'4px'}
                                >
                                    {(type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer) && (
                                        <Grid container xs={12} sm={12} md={12} xl={12} rowGap={3}>
                                            <Grid item xs={12} sm={12} md={12} xl={12} marginTop={'24px'}>
                                                <Alert severity="warning">
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontWeight: '500',
                                                            }}
                                                        >
                                                            {type === WALK_IN
                                                                ? 'Customer profile needs to be completed.'
                                                                : 'Customer information needs to be confirmed.'}
                                                        </div>

                                                        <div
                                                            onClick={() => {
                                                                if (isGuestCustomer) {
                                                                    setOpenGuestConvertModal(true);
                                                                } else {
                                                                    setOpenAddCustomerModal(true);
                                                                }
                                                            }}
                                                            style={{
                                                                color: '#0A66C2',
                                                                textDecoration: 'underline',
                                                                marginLeft: '2px',
                                                                fontWeight: '500',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            Confirm Now
                                                        </div>
                                                    </div>
                                                </Alert>
                                            </Grid>
                                        </Grid>
                                    )}
                                    <Grid
                                        style={{ display: type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer ? 'none' : '' }}
                                        container
                                        justifyContent={'start'}
                                        borderTop={'none'}
                                    >
                                        <Grid container item xs={12} sm={12} md={12} xl={12} rowGap={3}>
                                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                                {data?.lastAppointmentDate && (
                                                    <Stack spacing={2} sx={{ marginTop: '24px' }}>
                                                        <Alert
                                                            icon={<Info className="lastAppointmentIcon" />}
                                                            className="lastAppointment"
                                                            onClick={() => {
                                                                navigate(`/appointment/past-appointment/${data?.lastAppointmentId}`);
                                                            }}
                                                        >
                                                            <AlertTitle>Last Appointment: {dayjs(data.lastAppointmentDate).format('MMMM DD, YYYY')}</AlertTitle>
                                                            <Typography variant="body2" fontWeight={400}>
                                                                Vehicle Serviced: {data?.vehicle?.year && data?.vehicle?.year}{' '}
                                                                {data?.vehicle?.vehicleMake?.name && data?.vehicle?.vehicleMake?.name}{' '}
                                                                {data?.vehicle?.vehicleModel?.name && data?.vehicle?.vehicleModel?.name}{' '}
                                                                {data?.vehicle?.vehicleModelTrim?.name && data?.vehicle?.vehicleModelTrim?.name}
                                                            </Typography>
                                                        </Alert>
                                                    </Stack>
                                                )}
                                            </Grid>

                                            <Stack spacing={2} sx={{ width: '100%', padding: '16px' }}>
                                                <Grid item xs={12} sm={12} md={12} xl={12} padding={''}>
                                                    <Typography variant="h6" sx={{ fontWeight: 500, marginBottom: '16px' }}>
                                                        Recent Notes
                                                    </Typography>
                                                </Grid>
                                                <Grid container item xs={12} sm={12} md={12} xl={12}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                        type="text"
                                                        value={newNote}
                                                        onChange={(e) => setNewNote(e.target.value)}
                                                    />
                                                </Grid>
                                                {noteError && (
                                                    <p
                                                        style={{
                                                            color: '#d32f2f',
                                                            fontSize: '0.75rem',
                                                            letterSpacing: '0.03333em',
                                                            lineHeight: '1.66',
                                                            marginTop: '3px',
                                                        }}
                                                    >
                                                        Please enter note
                                                    </p>
                                                )}
                                                <Grid container xs={12} sm={12} md={12} xl={12} justifyContent={'end'}>
                                                    <Grid>
                                                        <Button variant="contained" color="secondary" size="large" onClick={handleAddNote}>
                                                            Add Note
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Stack>

                                            <Grid item container>
                                                {Array.isArray(notes) &&
                                                    notes?.map((data) => {
                                                        return (
                                                            <Grid
                                                                container
                                                                item
                                                                xs={12}
                                                                sm={12}
                                                                md={12}
                                                                xl={12}
                                                                style={{
                                                                    backgroundColor: '#e6f7f7',
                                                                    borderRadius: '8px',
                                                                    padding: '16px',
                                                                    marginBottom: '24px',
                                                                }}
                                                                // paddingBottom={"16px"}
                                                                display={'block'}
                                                            >
                                                                {/* <Card padding={"16px"} style={{backgroundColor:"#e6f7f7"}}> */}
                                                                <Stack direction={'row'} justifyContent={'space-between'} mb={2}>
                                                                    <div>
                                                                        <Typography variant="body1">
                                                                            {dayjs(data?.createdAt).format('MMMM DD, YYYY') +
                                                                                ' at ' +
                                                                                dayjs(data?.createdAt).format('h:mm A')}
                                                                        </Typography>
                                                                    </div>

                                                                    <div style={{ marginRight: '16px' }}>
                                                                        <Button
                                                                            variant="contained"
                                                                            onClick={(e) => {
                                                                                handleClickNoteActions(e, data);
                                                                            }}
                                                                            id={data?._id}
                                                                            aria-controls={openNoteActions ? 'demo-positioned-menu' : undefined}
                                                                            aria-haspopup="true"
                                                                            aria-expanded={openNoteActions ? 'true' : undefined}
                                                                            endIcon={<ExpandMoreIcon />}
                                                                        >
                                                                            Actions
                                                                        </Button>
                                                                        <Menu
                                                                            style={{ width: '300px' }}
                                                                            id="demo-positioned-menu"
                                                                            aria-labelledby={data?._id}
                                                                            anchorEl={anchorElAtions}
                                                                            open={openNoteActions}
                                                                            onClose={handleCloseNoteActions}
                                                                            anchorOrigin={{
                                                                                vertical: 'top',
                                                                                horizontal: 'left',
                                                                            }}
                                                                            transformOrigin={{
                                                                                vertical: 'top',
                                                                                horizontal: 'left',
                                                                            }}
                                                                        >
                                                                            <MenuItem
                                                                                onClick={() => {
                                                                                    handleCloseNoteActions();
                                                                                    setEditDeleteNoteId(selectedActionOfNote);
                                                                                    setEditNoteText(selectedActionOfNote?.notes);
                                                                                }}
                                                                            >
                                                                                {' '}
                                                                                <EditIcon style={{ marginRight: '10px' }} /> Edit Note
                                                                            </MenuItem>
                                                                            <MenuItem
                                                                                onClick={() => {
                                                                                    handleCloseNoteActions();
                                                                                    // setEditDeleteNoteId(
                                                                                    //   selectedActionOfNote
                                                                                    // );
                                                                                    deleteNote(selectedActionOfNote?._id);
                                                                                }}
                                                                            >
                                                                                {' '}
                                                                                <DeleteIcon style={{ marginRight: '10px' }} /> Delete Note
                                                                            </MenuItem>
                                                                        </Menu>
                                                                    </div>
                                                                </Stack>
                                                                {editDeleteNoteId?._id != data._id && (
                                                                    <Card
                                                                        style={{
                                                                            backgroundColor: '#fff',
                                                                            padding: '10px',
                                                                            marginRight: '10px',
                                                                            marginBottom: '8px',
                                                                            border: '1px solid #C4C4C4',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="body1"
                                                                            sx={{
                                                                                fontWeight: 400,
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            {data?.notes}
                                                                        </Typography>
                                                                    </Card>
                                                                )}
                                                                {editDeleteNoteId && editDeleteNoteId?._id == data?._id && (
                                                                    <>
                                                                        <TextField
                                                                            // value={data?.notes}
                                                                            style={{
                                                                                backgroundColor: '#fff',
                                                                                // padding: "10px",
                                                                                marginRight: '10px',
                                                                                marginBottom: '16px',
                                                                                // border: "1px solid #C4C4C4",
                                                                                width: '100%',
                                                                            }}
                                                                            value={editNoteText}
                                                                            onChange={(e) => setEditNoteText(e.target.value)}
                                                                        />
                                                                        <Button variant="contained" style={{ marginRight: '16px' }} onClick={() => editNote()}>
                                                                            SAVE
                                                                        </Button>
                                                                        <Button
                                                                            variant="outlined"
                                                                            onClick={() => {
                                                                                setEditDeleteNoteId('');
                                                                                setSelectedActionOfNote('');
                                                                            }}
                                                                        >
                                                                            CANCEL
                                                                        </Button>
                                                                    </>
                                                                )}
                                                            </Grid>
                                                        );
                                                    })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CustomTabPanel>

                        <div style={{ margin: '24px 0' }}>
                            <CustomTabPanel value={value} index={1}>
                                <Grid container rowGap={3}>
                                    {Array.isArray(vehicles) &&
                                        vehicles.map((item, index) => {
                                            if (item) {
                                                return (
                                                    <Grid
                                                        container
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        xl={12}
                                                        justifyContent={'space-between'}
                                                        boxShadow={2}
                                                        padding={'16px'}
                                                        borderRadius={'4px'}
                                                        alignItems="center"
                                                        backgroundColor={'#fff'}
                                                        key={item._id}
                                                        gap={1}
                                                    >
                                                        {/* <Grid
                              item
                              xs={12}
                              sm={12}
                              md={6}
                              lg={8}
                              xl={7}
                            ></Grid> */}

                                                        <Grid
                                                            item
                                                            direction={'row'}
                                                            display={'flex'}
                                                            flexDirection={'column'}
                                                            justifyContent={'start'}
                                                            alignItems={'start'}
                                                            xs={12}
                                                            gap={2}
                                                            spacing={2}
                                                        >
                                                            <Stack spacing={1}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        display: 'flex',
                                                                        fontWeight: 'medium',
                                                                        alignItems: 'center',
                                                                        gap: 1, // Optional: add spacing between icon and text
                                                                    }}
                                                                >
                                                                    <CustomerCar />
                                                                    <p style={{ margin: '0' }}>
                                                                        {item?.year ? item?.year : ''}
                                                                        {item?.vehicleYear ? item?.vehicleYear : ''}

                                                                        {item?.vehicleMake?.name ? ' ' + item?.vehicleMake?.name : ''}

                                                                        {item?.vehicleModel?.name ? ' ' + item?.vehicleModel?.name : ''}

                                                                        {item?.vehicleModelTrim?.name ? ' ' + item?.vehicleModelTrim?.name : ''}
                                                                        {item?.vehicleTrim?.name ? ' ' + item?.vehicleTrim?.name : ''}
                                                                    </p>
                                                                </Typography>
                                                                {item?.vehicleModelTrim?.description && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={1}>
                                                                        <CustomerTrim />
                                                                        {item?.vehicleModelTrim?.description}
                                                                    </Typography>
                                                                )}
                                                                {item?.vehicleTrim?.description && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={'2px'}>
                                                                        <Typography fontWeight={500} m={0}>
                                                                            Trim Desc:
                                                                        </Typography>
                                                                        {item?.vehicleTrim?.description}
                                                                    </Typography>
                                                                )}
                                                                {item?.vin && (
                                                                    <Typography
                                                                        variant="body1"
                                                                        gap={1}
                                                                        sx={{
                                                                            fontWeight: 400,
                                                                            display: 'flex',
                                                                            fontWeight: 'medium',
                                                                            alignItems: 'center',
                                                                            gap: 1, // Optional: add spacing between icon and text
                                                                        }}
                                                                    >
                                                                        <CustomerVin />
                                                                        <p style={{ display: 'flex', gap: 2, fontWeight: 'normal', margin: '0' }}>
                                                                            <Typography fontWeight={500}>VIN: </Typography>
                                                                            {item?.vin}
                                                                        </p>
                                                                    </Typography>
                                                                )}
                                                                {(item?.provinceCode || item?.licenseNumber || item?.license) && (
                                                                    <Typography
                                                                        variant="body1"
                                                                        gap={1}
                                                                        sx={{
                                                                            fontWeight: 400,
                                                                            display: 'flex',
                                                                            fontWeight: 'medium',
                                                                            alignItems: 'center',
                                                                            gap: 1, // Optional: add spacing between icon and text
                                                                        }}
                                                                    >
                                                                        <CustomerLicencePlate />
                                                                        <p style={{ display: 'flex', gap: 2, fontWeight: 'normal', margin: '0' }}>
                                                                            <Typography fontWeight={500}>
                                                                                {' '}
                                                                                {item?.provinceCode && item?.provinceCode + ' '}
                                                                            </Typography>

                                                                            {item?.licenseNumber && item?.licenseNumber}
                                                                            {item?.license && item?.license}
                                                                        </p>
                                                                    </Typography>
                                                                )}
                                                                {(type == SHOP_IMPORTED || type == WALK_IN
                                                                    ? importedCustomerData?.isFleetCustomer
                                                                    : data?.isFleetCustomer) && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={1}>
                                                                        <CustomerFleet />
                                                                        <Typography fontWeight={500} m={0}>
                                                                            Unit #: <span style={{ fontWeight: 400 }}>{item?.fleetUnitNumber}</span>
                                                                        </Typography>
                                                                    </Typography>
                                                                )}
                                                            </Stack>
                                                            {/* {type != SHOP_IMPORTED && ( */}
                                                            <Stack spacing={2} direction="row" justifyContent={'flex-end'} style={{ width: '100%' }}>
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        setOpenViewVehicle(true);
                                                                        // setEditVehicle({
                                                                        //   edit: true,
                                                                        //   index: index,
                                                                        //   id: item?._id,
                                                                        // });
                                                                        setViewVehicleData({ item, index });
                                                                        if (item?.isConverted == false) {
                                                                            setImportedVehicleId(item?._id);
                                                                        }
                                                                        // setShowEditDeleteInViewModel(
                                                                        //   item?.isConverted == false ? false : true
                                                                        // );
                                                                    }}
                                                                >
                                                                    View
                                                                </Button>
                                                                {/* {item?.isConverted !== false && (
                                    <> */}
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        setEditVehicle({
                                                                            edit: true,
                                                                            index: index,
                                                                            id: item?._id,
                                                                            data: item,
                                                                        });
                                                                        if (item?.isConverted == false) {
                                                                            setImportedVehicleId(item?._id);
                                                                        }
                                                                        setOpen(true);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    onClick={() => {
                                                                        setDeleteVehicleId(item?._id);
                                                                        setOpenVehicleDelete(true);
                                                                        if (item?.isConverted == false) {
                                                                            setImportedVehicleId(item?._id);
                                                                        }
                                                                    }}
                                                                    disabled={vehicles?.length == 1}
                                                                >
                                                                    DELETE
                                                                </Button>
                                                                {/* </>
                                  )} */}
                                                            </Stack>
                                                            {/* )} */}
                                                        </Grid>
                                                    </Grid>
                                                );
                                            }
                                        })}
                                </Grid>
                            </CustomTabPanel>
                        </div>

                        <div style={{ margin: '24px 0' }}>
                            <CustomTabPanel value={value} index={2} style={{ display: type == SHOP_IMPORTED || type == WALK_IN ? 'none' : '' }}>
                                <AppointmentTab customerId={id} getAppointmentDetails={getAppointmentDetails} />
                            </CustomTabPanel>
                        </div>

                        <CustomTabPanel value={value} index={3}>
                            <InvoiceTab customerId={id} getAppointmentDetails={getAppointmentDetails} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={4}>
                            <EstimateTab customerId={id} />
                        </CustomTabPanel>
                    </Box>
                    {/* </Grid> */}
                </Grid>
            </Grid>
            {openEditCustomer && (
                <Suspense fallback={<CircularProgress />}>
                    <AddCustomerModalV4
                        openModal={openEditCustomer}
                        onClose={handleCloseCustomer}
                        onSubmitModal={async (resp, isUserDeleted) => {
                            if (isUserDeleted) {
                                navigate('/customers', { replace: true });
                                return;
                            }
                            handleCloseCustomer();
                            fetchCustomerDetail();
                            if (resp) {
                                setOpenSuccessModal(true);
                                setSuccessMessage('Customer Details Updated');
                                setSuccessMessageType('success');
                                if (quickEdit) {
                                    setQuickEdit(false);
                                }
                            }
                        }}
                        customerId={id}
                        customerType={type}
                        fromProfile={true}
                    />
                </Suspense>
            )}
            <CommonDialog
                loader={showLoader}
                open={openDelete}
                onClose={handleCloseDelete}
                onSave={async () => {
                    setShowLoader(true);
                    const resp = await dispatch(deleteCustomer(id));
                    if (resp) {
                        setTimeout(() => {
                            handleCloseDelete();
                            setShowLoader(false);
                            navigate('/customers');
                            setOpenSuccessModal(true);
                            setSuccessMessageType('success');
                            setSuccessMessage('Customer Deleted');
                        }, 2500);
                    } else {
                        setShowLoader(false);
                    }
                }}
                dialogTitle="Delete Customer?"
                dialogSubtitle="Are you sure you want to delete this customer?"
                saveButtonText="DELETE"
                saveButtonType="error"
                cancelButtonText="CANCEL"
            />
            <CommonDialog
                loader={showLoader}
                open={openVehicleDelete}
                onClose={handleCloseDeleteVehicle}
                onSave={handleDeleteVehicle}
                dialogTitle="Delete Vehicle"
                dialogSubtitle="Are you sure you want to delete this vehicle?"
                saveButtonText="DELETE"
                saveButtonType="error"
                cancelButtonText="CANCEL"
            />
            <Modal open={openViewVehicle} onClose={handleCloseViewVehicle} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
                <Box
                    sx={{
                        ...style,
                        width: '624px',
                        // overflowY: "scroll",
                    }}
                >
                    <AppBar
                        color="secondary"
                        variant="elevation"
                        sx={{
                            height: '64px',
                            paddingRight: '0px !important',
                        }}
                    >
                        <Toolbar variant="regular">
                            <Typography variant="h6" width={'98%'} color={'white'}>
                                Vehicle
                            </Typography>
                            <Stack direction={'row'} spacing={0}>
                                <div
                                    onClick={() => {
                                        handleCloseViewVehicle();
                                        setEditVehicle({ edit: false, index: '', id: '' });
                                    }}
                                    style={{ cursor: 'pointer', height: '32px' }}
                                >
                                    <CloseIcon style={{ color: '#0000008F', fontSize: 32 }} />
                                </div>
                            </Stack>
                        </Toolbar>
                    </AppBar>
                    <Container
                        gap={0}
                        disableGutters
                        className="viewVehicleModal"
                        style={{
                            scrollbarColor: 'blue',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                            marginTop: '64px',
                            maxHeight: '600px',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px',
                                marginBottom: '24px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                                    gap: '12px',
                                }}
                            >
                                <Tabs
                                    value={viewVehicleModalTabvalue}
                                    onChange={handleChangeViewVehicleTabValue}
                                    aria-label="basic tabs example"
                                    sx={{
                                        flex: 1,
                                        minWidth: 0,
                                        maxWidth: '100%',
                                        overflow: 'hidden',
                                    }}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label="OVERVIEW"
                                        // style={{ display: type == SHOP_IMPORTED && "none" }}
                                        {...a11yProps(0)}
                                    />

                                    <Tab label="ENGINE" {...a11yProps(1)} />
                                    <Tab
                                        label="APPOINTMENTS"
                                        style={{ display: type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer ? 'none' : '' }}
                                        {...a11yProps(2)}
                                    />
                                    <Tab
                                        label="Invoices"
                                        style={{ display: type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer ? 'none' : '' }}
                                        {...a11yProps(3)}
                                    />
                                    <Tab
                                        label="Estimates"
                                        style={{ display: type == SHOP_IMPORTED || type == WALK_IN || isGuestCustomer ? 'none' : '' }}
                                        {...a11yProps(4)}
                                    />
                                </Tabs>
                                {config?.carfaxSettings?.canFetchROHistory && (
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            height: 'max-content',
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0,
                                            ml: { xs: 0, sm: 2 },
                                            mt: { xs: 1, sm: 0 },
                                        }}
                                        onClick={() => {
                                            if (
                                                (vehicles && vehicles[viewVehicleData?.index]?.vin) ||
                                                (vehicles && vehicles[viewVehicleData?.index]?.licenseNumber)
                                            ) {
                                                setOpenCarfaxHistory(true);
                                                handleCloseViewVehicle();
                                            } else {
                                                setSuccessMessage('Please enter licence plate or VIN to retrieve the Carfax Report.');
                                                setOpenSuccessModal(true);
                                                setSuccessMessageType('error');
                                            }
                                        }}
                                    >
                                        VIEW CARFAX REPORT
                                    </Button>
                                )}
                            </Box>
                        </Box>
                        <CustomTabPanel value={viewVehicleModalTabvalue} index={0}>
                            <Grid container item spacing={2} color={'#000000'}>
                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        VIN
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vin}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Year
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.year
                                            ? vehicles && vehicles[viewVehicleData?.index]?.year
                                            : vehicles && vehicles[viewVehicleData?.index]?.vehicleYear}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Make
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleMake?.name}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Model
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModel?.name}
                                    </Grid>
                                </Grid>
                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Trim
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.name}
                                    </Grid>
                                </Grid>
                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Trim Description
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.description}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Licence Plate
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.licenseNumber}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CustomTabPanel>
                        <CustomTabPanel value={viewVehicleModalTabvalue} index={1}>
                            <Grid container item spacing={2} color={'#000000'}>
                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Engine Type
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.engineType}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Engine Fuel Type
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.engineFuelType}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Engine Drive Type
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.engineDriveType}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Engine Transmission
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.engineTransmission}
                                    </Grid>
                                </Grid>

                                <Grid container item>
                                    <Grid item md={4} fontSize={'16px'} lineHeight={'150%'} letterSpacing={'0.15px'} fontWeight={500}>
                                        Body Type
                                    </Grid>
                                    <Grid item md={8} fontSize={'16px'} fontWeight={400}>
                                        {vehicles && vehicles[viewVehicleData?.index]?.vehicleModelTrim?.bodyType}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CustomTabPanel>

                        <CustomTabPanel value={viewVehicleModalTabvalue} index={2}>
                            <AppointmentTab customerId={id} getAppointmentDetails={getAppointmentDetails} vehicleId={viewVehicleData?.item?._id || null} />
                        </CustomTabPanel>

                        <CustomTabPanel value={viewVehicleModalTabvalue} index={3}>
                            <InvoiceTab customerId={id} getAppointmentDetails={getAppointmentDetails} vehicleId={viewVehicleData?.item?._id || null} />
                        </CustomTabPanel>

                        <CustomTabPanel value={viewVehicleModalTabvalue} index={4}>
                            <EstimateTab customerId={id} vehicleId={viewVehicleData?.item?._id || null} />
                        </CustomTabPanel>

                        {/* {showEditDeleteInViewModel && ( */}
                        {viewVehicleModalTabvalue === 0 && (
                            <Stack spacing={2} direction="row" justifyContent="flex-end" marginTop="24px">
                                <Button
                                    variant="contained"
                                    color="error"
                                    sx={{
                                        height: '42px',
                                        lineHeight: '26px',
                                        letterSpacing: '0.46px',
                                        fontSize: '15px',
                                    }}
                                    onClick={() => {
                                        setDeleteVehicleId(viewVehicleData?.item?._id);
                                        setOpenVehicleDelete(true);
                                    }}
                                    disabled={vehicles?.length == 1}
                                >
                                    DELETE
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        height: '42px',
                                        lineHeight: '26px',
                                        letterSpacing: '0.46px',
                                        fontSize: '15px',
                                    }}
                                    onClick={() => {
                                        setOpen(true);
                                        handleCloseViewVehicle();
                                        setEditVehicle({
                                            edit: true,
                                            index: viewVehicleData?.index,
                                            id: viewVehicleData?.item?._id,
                                            data: viewVehicleData?.item,
                                        });
                                        if (type == SHOP_IMPORTED || type == WALK_IN) setYearValue(vehicles[editVehicle.index]?.vehicleYear + '');
                                        else {
                                            setYearValue(vehicles[editVehicle.index]?.year + '');
                                        }

                                        // fetchVehicleMake({
                                        //   page: makeValuePage,
                                        //   limit: 500,
                                        //   year:
                                        //     type == SHOP_IMPORTED
                                        //       ? vehicles[editVehicle.index]?.vehicleYear
                                        //       : vehicles[editVehicle.index]?.year,
                                        // });
                                        // fetchVehicleModel({
                                        //   page: modelValuePage,
                                        //   limit: 1000,
                                        //   vehicleMakeId:
                                        //     vehicles[editVehicle.index]?.vehicleMake?._id,
                                        //   year:
                                        //     type == SHOP_IMPORTED
                                        //       ? vehicles[editVehicle.index]?.vehicleYear
                                        //       : vehicles[editVehicle.index]?.year,
                                        // });
                                        // fetchVehicleTrim({
                                        //   page: trimValuePage,
                                        //   limit: 1000,
                                        //   vehicleMakeId:
                                        //     vehicles[editVehicle.index]?.vehicleMake?._id,
                                        //   vehicleModelId:
                                        //     vehicles[editVehicle.index]?.vehicleModel?._id,
                                        //   year:
                                        //     type == SHOP_IMPORTED
                                        //       ? vehicles[editVehicle.index]?.vehicleYear
                                        //       : vehicles[editVehicle.index]?.year,
                                        // });
                                        // setValueinForm("vin", vehicles[editVehicle.index]?.vin);
                                        // setValueinForm(
                                        //   "year",
                                        //   (type == SHOP_IMPORTED
                                        //     ? vehicles[editVehicle.index]?.vehicleYear
                                        //     : vehicles[editVehicle.index]?.year) + ""
                                        // );

                                        // setValueinForm(
                                        //   "vehicleMakeId",
                                        //   vehicles[editVehicle.index]?.vehicleMake?._id
                                        // );
                                        // setValueinForm(
                                        //   "vehicleModelId",
                                        //   vehicles[editVehicle.index]?.vehicleModel?._id
                                        // );
                                        // setValueinForm(
                                        //   "vehicleModelTrimId",
                                        //   vehicles[editVehicle.index]?.vehicleModelTrim?._id
                                        // );

                                        // setMakeValue(vehicles[editVehicle.index]?.vehicleMake?._id);
                                        // setModelValue(vehicles[editVehicle.index]?.vehicleModel?._id);
                                        // setTrimValue(
                                        //   vehicles[editVehicle.index]?.vehicleModelTrim?._id
                                        // );

                                        // setValueinForm(
                                        //   "licenseNumber",
                                        //   vehicles[editVehicle.index]?.licenseNumber
                                        // );
                                    }}
                                >
                                    EDIT
                                </Button>
                            </Stack>
                        )}
                        {/* )} */}
                    </Container>
                </Box>
            </Modal>
            {console.log}
            <VehicleModalV4
                open={open}
                onClose={handleClose}
                customerId={id}
                vehicleId={editVehicle?.edit ? editVehicle.id : null}
                mode={editVehicle?.edit ? (importedVehicleId ? 'update_shop_imported_vehicle' : 'update_shop_created_vehicle') : 'create'}
                vehicleData={
                    editVehicle?.edit && editVehicle?.data
                        ? {
                              _id: editVehicle.data._id,
                              vin: editVehicle.data.vin || '',
                              year: editVehicle.data.year || editVehicle.data.vehicleYear || '',
                              vehicleMakeId: editVehicle.data.vehicleMake?._id,
                              vehicleModelId: editVehicle.data.vehicleModel?._id || editVehicle.data.vehicleModelId?._id,
                              vehicleModelTrimId: editVehicle.data.vehicleModelTrim?._id || editVehicle.data.vehicleModelTrimId?._id,
                              licenseNumber: editVehicle.data.licenseNumber || editVehicle.data.license || '',
                              provinceId: editVehicle.data.provinceId || editVehicle.data.province?._id,
                              fleetUnitNumber: editVehicle.data.fleetUnitNumber || '',
                          }
                        : null
                }
                isFleetCustomer={type === SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.isFleetCustomer : data?.isFleetCustomer}
                enableLicenseDecoding={false}
                onSuccess={() => {
                    fetchCustomerVehicle();
                    if (type === SHOP_IMPORTED || type == WALK_IN) {
                        fetchImportedCustomerDetail();
                    }
                    setOpenSuccessModal(true);
                    setSuccessMessage(editVehicle?.edit ? 'Vehicle Updated' : 'New Vehicle Added');
                }}
            />
            <AppointmentModel
                open={openAppointmentDetailModal}
                handleClose={handleCloseAppointmentDetailModal}
                data={appointmentDetailData}
                status={appointmentDetailData?.status}
                setUpdateStatus={() => {}}
                setAppointmentDropOffODo={() => {}}
                setAppointmentCompletionOffODo={() => {}}
                setSelectId={() => {}}
                recallDetailsAPI={() => {
                    getAppointmentDetails(appointmentDetailData?._id);
                }}
            />

            {appointmentDetailData && (
                <AppointmentRequestModal
                    open={openAppReqModal}
                    handleClose={() => setOpenAppReqModal(false)}
                    appointmentData={appointmentDetailData}
                    id={appointmentDetailData._id}
                    handleCancelAppointment={() => setOpenAppReqModal(false)}
                    apiCall={getAppointmentDetails}
                />
            )}

            {/* <AppointmentRescheduleRequestModal
      // open={rescheduledRequestOpen}
      // setOpen={setRescheduledRequestOpen}
      // appointmentData={appointment}
      // id={appointmentId}
      // apiCall={dashboardDetails}
      /> */}
            <ViewUpcomingModal
                open={showUpcomingModal}
                handleClose={handleCloseUpComing}
                upcomingData={appointmentDetailData}
                handleCancelModel={handleCloseUpComing}
                recallDetailsAPI={() => {}}
            />
            {/* <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} alertType={successMessageType} /> */}
            {/* <ConfirmCustomersInfoModel
                //  open={openCustomerInfo}
                //  handleClose={() => setOpenCustomerInfo(false)}
                // handleClose ={}
                customerData={importedCustomerData}
                id={importedCustomerData?._id}
                // vehicalDetailFunction={}
                setAddCustomerInfoButton={setAddCustomerInfoButton}
                setCustomerData={setImportedCustomerData}
                convertedCustomerId={convertedCustomerId}
                setCustomerConvertedId={setCustomerConvertedId}
                madeFromCustomerProfile={true}
                setOpenDelete={setOpenDelete}
                // setCustomerTypeData={}
                // state={}
                // setState={}
                // setAddVehicleInfoButton={}
                // data={}
                // vehicleInfo={}
            /> */}
            {openAddCustomerModal && (
                <Suspense fallback={<CircularProgress />}>
                    <AddCustomerModalV4
                        openModal={openAddCustomerModal}
                        onClose={() => {
                            setOpenAddCustomerModal(false);
                        }}
                        onSubmitModal={async (resp, isUserDeleted) => {
                            if (isUserDeleted) {
                                navigate('/customers', { replace: true });
                                return;
                            }

                            let convertedCustId = resp?._id;
                            setCustomerConvertedId(convertedCustId);
                            navigate(`/customers/${convertedCustId}/${USER_TYPES.SHOP_CREATED}`, {
                                replace: true,
                            });
                        }}
                        customerId={id || importedCustomerData?._id || null}
                        customerType={type || importedCustomerData.createdFrom ? USER_TYPES.SHOP_IMPORTED : USER_TYPES.SHOP_CREATED || importedCustomerData}
                        customerData={importedCustomerData}
                        fromProfile={true}

                        // customerType={type || (importedCustomerData?.createdFrom === 'shop_imported' ? USER_TYPES.SHOP_IMPORTED : USER_TYPES.SHOP_CREATED)}
                        // importedCustomerData={importedCustomerData}
                    />
                </Suspense>
            )}

            <CarfaxHistoryModel open={openCarfaxHistory} handleClose={handleCloseCarfaxHistory} vehicleData={viewVehicleData} />
            <Dialog open={appointmentModalLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>

            <GuestCustomerInfoModal
                userData={guestModalUserData}
                openGuestModal={openGuestModal}
                setOpenGuestModal={setOpenGuestModal}
                showBtn
                showTag={false}
                onCustomerConverted={(convertedUser) => {
                    if (convertedUser?._id) {
                        navigate(`/customers/${convertedUser._id}/${convertedUser?.createdFrom ? convertedUser.createdFrom : USER_TYPES.SHOP_CREATED}`, {
                            replace: true,
                        });
                    }
                }}
            />

            {openGuestConvertModal && (
                <ConvertCustomerModal
                    showBtn={true}
                    userId={guestConvertUserId}
                    openConvertModal={openGuestConvertModal}
                    handleCloseCustomer={(resp) => {
                        setOpenGuestConvertModal(false);
                        const convertedUser = resp?.data ?? resp;
                        if (convertedUser?._id) {
                            navigate(`/customers/${convertedUser._id}/${convertedUser?.createdFrom ? convertedUser.createdFrom : USER_TYPES.SHOP_CREATED}`, {
                                replace: true,
                            });
                        }
                    }}
                    addressValues={addressValues}
                    setAddressValue={setAddressValue}
                    primaryEmailIndex={primaryEmailIndex}
                    setPrimaryEmailIndex={setPrimaryEmailIndex}
                    setOpenDelete={() => {}}
                />
            )}
        </Box>
    );
};

export default Profile;
